export default __webpack_public_path__ + "static/ian-paget@2x-83b3356181107478cd4a8a4d77c7229a.png";